export default __webpack_public_path__ + "static/media/(16).b9a57316.jpeg";